export default __webpack_public_path__ + "static/media/courseImage.a6e4d8df.svg";